/**
 * Contains/loads the jQuery plugins shared by both the editor and viewer applications.
 */
define((require) => {
    "use strict";

    require("jquery");
    require("jquery-visibility");
    require("jquery-touchswipe");
    require("jquery-activate");
});



// WEBPACK FOOTER //
// ./src/shared/util/JqueryCommonPlugins.js